import { GET_MITARBEITER_BY_STANDORT_ID } from '@/domain/navigation/benachrichtigungen/graphql/queries';
import {
  Arbeitsbereich,
  Mitarbeiter,
} from '@/domain/navigation/benachrichtigungen/types/Benachrichtungen';
import {
  GetMitarbeiterQuery,
  GetMitarbeiterQueryVariables,
} from '@/gql/graphql';
import { useQuery } from '@apollo/client/react';
import * as Sentry from '@sentry/react';

export function useMitarbeiter({ standortId }: { standortId: string }): {
  data: Mitarbeiter[];
  loading: boolean;
} {
  const { data, error, loading } = useQuery<
    GetMitarbeiterQuery,
    GetMitarbeiterQueryVariables
  >(GET_MITARBEITER_BY_STANDORT_ID, {
    variables: { standortId },
  });

  if (loading) {
    return {
      data: [],
      loading: true,
    };
  }

  if (error) {
    Sentry.captureException(error);
    return {
      data: [],
      loading: false,
    };
  }

  const mitarbeiter = data.navigation_mitarbeiter.map(
    (m) =>
      new Mitarbeiter({
        id: m.id,
        vorname: m.vorname,
        nachname: m.nachname,
        bildUrl: m.bildUrl,
        arbeitnehmertyp: m.arbeitnehmertyp,
        arbeitsbereich: new Arbeitsbereich({
          markierung: m.arbeitsbereich.markierung.toString(),
          id: m.arbeitsbereich.id,
          name: m.arbeitsbereich.name,
        }),
      }),
  );

  return {
    data: mitarbeiter,
    loading: false,
  };
}
